var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContainerWrapper',{attrs:{"title":_vm.pageTitle,"no-white-container":_vm.isNewForm}},[_c(_vm.dynamicInvoiceFormComponent,{ref:"invoiceForm",tag:"component",attrs:{"is-editable":!_vm.editDisabled,"is-edit-eet-invoice-disabled":_vm.editModeEetInvoice,"correction-invoice-redirect":_vm.correctionInvoiceRedirect}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }